import styled from "styled-components";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";
const isB2u = process.env.GATSBY_BUSINESS_VERTICAL === "b2u";

export const AccordionContentWrapper = styled.div`
	display: flex;
	gap: 1rem;
	flex-direction: column;
	.accordion-content {
		display: flex;
		align-items: start;
		justify-content: space-between;
	}
	.footer-text {
		${(props) => (props.footerTextHasMargin ? "margin-top: 1rem;" : "")}
		a, a *, a:visited * {
			text-decoration: underline;
			color: inherit;
			&:hover {
				color: var(--theme-primary, var(--secondary-purple-300));
			}
		}
	}
	.accordion-content-text-heading {
		width: 45%;
	}
	.accordion-content-text-value {
		width: 35%;
	}
	${isB2u &&
	`
    .plus-minus-svg {
      margin-top: 5px;
    }
  `}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.accordion-content-text-heading {
			width: 50%;
		}
		.accordion-content-text-value {
			width: 50%;
		}
	}
	.text-end {
		text-align: end;
	}
`;
export const PricingWrapper = styled.div`
	padding: 5rem 0;
	.pricing-heading-wrapper {
		display: flex;
		gap: 1.5rem;
		flex-direction: column;
	}
	.card-image {
		object-fit: cover;
		width: 100%;
		height: 13rem;
	}
	.pricing-accordion-heading {
		padding-inline: 0;
		align-items: flex-start;
	}
	.pricing-accordion-content {
		padding: 0 2rem 1.5rem 0;
	}
	.pricing-description {
		.val {
			color: var(--primary-neutral-nightshade-600);
		}
	}
	.accordion-pricing-grid {
		margin: 3.5rem 0;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		padding: 2.5rem 0;
		.card-image {
			object-fit: cover;
			width: 100%;
			height: 100%;
		}
		.pricing-heading-wrapper {
			gap: 1rem;
		}
		.pricing-accordion-content {
			padding: 0 0 1.5rem 0;
		}
		.accordion-pricing-grid {
			margin: 2rem 0rem;
		}
	}
`;
export const AccordionHeadingWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	gap: 1rem;
	.flex-gap_05 {
		display: flex;
		gap: 0.5rem;
	}

	.accordion-heading-line-through-price {
		text-decoration: line-through;
	}
	.accordion-heading-right-wrapper {
		max-width: 60%;
	}
	.accordion-heading-left-wrapper,
	.accordion-heading-right-wrapper {
		flex-direction: column;
	}
	.accordion-pricing-badge {
		height: 1.3rem;
	}
	.below-text {
		text-align: center;
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		gap: 0.5rem;
		.below-text {
			text-align: start;
		}
		.accordion-heading-right-wrapper {
			max-width: 100%;
		}
		flex-direction: column;
	}
`;
export const ChartCardWrapper = styled.div`
	padding: 2rem;
	display: flex;
	flex-direction: column;
	border-radius: 0.5rem;
	background-color: var(--primary-green-50);
	gap: 1rem;
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		margin-top: 1rem;
	}
`;
